import React, { useCallback } from 'react'
import { useNavigate } from 'react-router'

import { useProjectStore } from 'features/project/store'
import { AgentList } from 'features/trend-detection/features/agent-list'
import {
  trendDetectionAgentConfigPath,
  trendDetectionAgentCreatePath,
} from 'features/trend-detection/paths'
import { useTrendDetectionService } from 'features/trend-detection/service'
import type { ProjectState } from 'types/project'

/** Settings: table of agents. */
export const AgentsListPage: React.FC = () => {
  const service = useTrendDetectionService()
  const navigate = useNavigate()
  const projectId = useProjectStore((s: ProjectState) => s.projectId)

  // The agent-events SSE connection that keeps the list's run-status cells live
  // (it invalidates the issue-agents / benchmarking-agents queries on each
  // transition) is owned app-wide by ProjectLayout — no page-scoped mount here.

  const createPath = projectId ? trendDetectionAgentCreatePath(projectId) : ''

  const onSelectAgent = useCallback(
    (uuid: string) => {
      if (!projectId) return
      navigate(trendDetectionAgentConfigPath(projectId, uuid))
    },
    [navigate, projectId],
  )

  const onEditAgent = useCallback(
    (uuid: string) => {
      if (!projectId) return
      navigate(`${trendDetectionAgentConfigPath(projectId, uuid)}?mode=edit`)
    },
    [navigate, projectId],
  )

  if (!projectId) return null

  return (
    <AgentList
      service={service}
      createPath={createPath}
      onSelectAgent={onSelectAgent}
      onEditAgent={onEditAgent}
    />
  )
}
